import { render, staticRenderFns } from "./mcqAnswer.vue?vue&type=template&id=4d3a8a6a"
import script from "./mcqAnswer.vue?vue&type=script&lang=js"
export * from "./mcqAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports